import ApiClient from '../ApiClient';

class WgptCustomDashboardsAPI extends ApiClient {
  constructor() {
    super('custom_dashboards', { accountScoped: true, wgpt: true });
  }
}

export default new WgptCustomDashboardsAPI();
